var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, CustomElement, Watch, PropertyConverters, Utils, PropertyChangeEventName, Debounce, Components } from '@pacem/pacem-core';
//namespace Pacem.Components.Networking {
let PacemServerSentEventsListenerElement = class PacemServerSentEventsListenerElement extends Components.PacemItemElement {
    constructor() {
        super(...arguments);
        this._receiveHandler = (e) => {
            this.dispatchEvent(new CustomEvent('receive', { detail: e.data }));
        };
        this._connectedHandler = (e) => {
            if (e.detail.propertyName === 'connected' && e.detail.currentValue === true) {
                this._start();
            }
        };
    }
    get _isConnected() {
        return this.container instanceof PacemServerSentEventsProxyElement && this.container.connected || false;
    }
    get _connection() {
        return this.container instanceof PacemServerSentEventsProxyElement && this.container.eventSource || null;
    }
    _stop(method = this.method) {
        if (!this._isConnected) {
            return;
        }
        const conn = this._connection;
        if (!Utils.isNullOrEmpty(method)) {
            conn.removeEventListener(method, this._receiveHandler);
        }
    }
    _start(method = this.method) {
        if (!this._isConnected) {
            return;
        }
        const conn = this._connection;
        if (!Utils.isNullOrEmpty(method)) {
            conn.addEventListener(method, this._receiveHandler);
        }
    }
    /** Start listening, if not disabled. */
    start() {
        if (!this.disabled) {
            this._start();
        }
    }
    /** Stop listening. */
    stop() {
        this._stop();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        const container = this.container;
        if (!Utils.isNull(container)) {
            container.addEventListener(PropertyChangeEventName, this._connectedHandler, false);
        }
        this.start();
    }
    disconnectedCallback() {
        const container = this.container;
        if (!Utils.isNull(container)) {
            container.removeEventListener(PropertyChangeEventName, this._connectedHandler, false);
        }
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'method':
                if (!Utils.isNullOrEmpty(old)) {
                    this._stop(old);
                }
                if (!Utils.isNullOrEmpty(val)) {
                    this._start(val);
                }
                break;
            case 'disabled':
                if (!Utils.isNullOrEmpty(this.method)) {
                    let toggle = val ? this._stop : this._start;
                    toggle();
                }
                break;
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemServerSentEventsListenerElement.prototype, "method", void 0);
PacemServerSentEventsListenerElement = __decorate([
    CustomElement({ tagName: P + '-sse-listener' })
], PacemServerSentEventsListenerElement);
export { PacemServerSentEventsListenerElement };
let PacemServerSentEventsProxyElement = class PacemServerSentEventsProxyElement extends Components.PacemItemsContainerElement {
    constructor() {
        super(...arguments);
        this._connectHandler = (_) => {
            this.connected = true;
            this.#evtSource.onmessage = this._receiveHandler;
        };
        this._errorHandler = (_) => {
            this.connected = false;
        };
        this._receiveHandler = (e) => {
            this.dispatchEvent(new CustomEvent('receive', { detail: e.data }));
        };
    }
    validate(item) {
        return item instanceof PacemServerSentEventsListenerElement;
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._start();
    }
    disconnectedCallback() {
        this._stop();
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        //
        if (first) {
            return;
        }
        if (name === 'url' || name === 'disabled') {
            this._restart();
        }
    }
    #evtSource;
    _restart() {
        this._stop();
        this._start();
    }
    _start(url = this.url) {
        if (!Utils.isNullOrEmpty(url) && !this.disabled) {
            const evtSource = this.#evtSource = new EventSource(url);
            evtSource.onopen = this._connectHandler;
            evtSource.onerror = this._errorHandler;
        }
    }
    get eventSource() {
        return this.#evtSource;
    }
    _stop() {
        const listeners = this.items || [];
        for (var item of listeners) {
            item.stop();
        }
        const evtSource = this.#evtSource;
        if (!Utils.isNull(evtSource)) {
            evtSource.onopen = null;
            evtSource.onerror = null;
            evtSource.onmessage = null;
            evtSource.close();
        }
        this.connected = false;
        this.#evtSource = null;
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemServerSentEventsProxyElement.prototype, "url", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemServerSentEventsProxyElement.prototype, "connected", void 0);
__decorate([
    Debounce(true)
], PacemServerSentEventsProxyElement.prototype, "_restart", null);
PacemServerSentEventsProxyElement = __decorate([
    CustomElement({ tagName: P + '-sse-proxy' })
], PacemServerSentEventsProxyElement);
export { PacemServerSentEventsProxyElement };
